/**
 * api 层的全局错误提示出口。
 *
 * axios 拦截器确实需要弹 toast（后端返非成功码、404 等），但 api 层不该**静态**
 * 依赖某个具体 toast 库：`@/api` barrel 有 ~270 个消费者，静态 import 会把 sonner
 * 塞进所有人的急切模块图（冷缓存下每个消费者的单测都要为此多转换一遍）。
 *
 * 这里用动态 `import()`：它不进静态图，而 app 里 `<Toaster />`（toast-provider.tsx）
 * 本来就把 sonner 加载好了，所以运行时没有额外的 chunk 代价，只差一个微任务。
 *
 * 刻意**不**做依赖注入（让 app 启动时注册 handler）：那会引入一个"没注册就静默丢
 * 提示"的失败模式，而且 app 启动早期的 api 错误正好落在注册之前的窗口里。
 * 这里加载失败也会 console.error 出原始文案，不会把错误吞掉。
 *
 * 不变量由 `src/api/__tests__/apiBarrelGraph.test.ts` 守着。
 */
export function notifyError(message: string): void {
  void import('sonner')
    .then((m) => m.toast.error(message))
    .catch((e) => {
      // 兜底：toast 组件加载不出来时，至少别把错误信息吞了
      console.error('[api] toast 加载失败，原始错误信息:', message, e)
    })
}
